import * as Sentry from '@sentry/browser'

import * as debug from 'airship/modules/debug'

export interface Extra {
  [key: string]: unknown
}

/**
 * Report an error to Sentry
 * @param err Error to be reported
 * @param extra (optional) Any additional context to pass along
 * @param level (optional) A severity level
 */
export default function reportError(
  err: Error,
  extra: Extra = {},
  level?: Sentry.Severity
) {
  Sentry.withScope(scope => {
    Object.entries(extra).forEach(([key, value]) => {
      scope.setExtra(key, value)
    })

    if (level) {
      scope.setLevel(level)
    }

    Sentry.captureException(err)

    if (debug()) {
      // eslint-disable-next-line no-console
      console.debug('[ERROR REPORTED]', err, extra, level)
    }
  })
}
